"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ajv_1 = __importDefault(require("ajv"));
var index_1 = require("./index");
var DynamicRangeValidator = /** @class */ (function () {
    function DynamicRangeValidator() {
        this.ajv = new ajv_1.default();
        this.templateValidator = this.ajv
            .addSchema(index_1.DynamicRangeTemplateSchemas.dependencies)
            .compile(index_1.DynamicRangeTemplateSchemas.mainSchema);
        this.catalogValidator = this.ajv
            .addSchema(index_1.DynamicRangeCatalogSchemas.dependencies)
            .compile(index_1.DynamicRangeCatalogSchemas.mainSchema);
    }
    DynamicRangeValidator.prototype.validate = function (catalog, template) {
        var templateData = JSON.parse(template);
        var templateIsValid = this.templateValidator(templateData);
        var catalogData = JSON.parse(catalog);
        var catalogIsValid = this.catalogValidator(catalogData);
        return {
            valid: templateIsValid && catalogIsValid,
            catalog: {
                valid: catalogIsValid,
                errors: this.catalogValidator.errors
            },
            template: {
                valid: templateIsValid,
                errors: this.templateValidator.errors
            }
        };
    };
    DynamicRangeValidator.prototype.validateCatalog = function (catalog) {
        var catalogData = JSON.parse(catalog);
        var catalogIsValid = this.catalogValidator(catalogData);
        return {
            valid: catalogIsValid,
            errors: this.catalogValidator.errors
        };
    };
    DynamicRangeValidator.prototype.validateTemplate = function (template) {
        var tempalteData = JSON.parse(template);
        var templateIsValid = this.templateValidator(tempalteData);
        return {
            valid: templateIsValid,
            errors: this.templateValidator.errors
        };
    };
    return DynamicRangeValidator;
}());
exports.default = DynamicRangeValidator;
//# sourceMappingURL=DynamicRangeValidator.js.map